import Vue from 'vue'
import Vuex from 'vuex'
import { IAppState } from './modules/app'
import { IAsrOfflineTaskState } from './modules/asr-offline'
import { IUserState } from './modules/user'
import { IAsrRtState } from './modules/asr-rt'
import { ISimpleUploaderState } from './modules/simple-uploader'

Vue.use(Vuex)

export interface IRootState {
  app: IAppState
  user: IUserState
  asrOffline: IAsrOfflineTaskState,
  asrRt: IAsrRtState,
  simpleUploader: ISimpleUploaderState
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({})
